import { defineMessages } from '@cookbook/solid-intl'

// Split out of `booking-management-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Manage your bookings on Lodgr. View, update, and track your reservations quickly and easily.',
        id: 'BookingManagementPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Booking Management | Lodgr',
        id: 'BookingManagementPage.titleMessage',
    }),
}
